/* -----------------UI--------------- */
import { Dialog } from "react-native-paper";

import { useReview } from "@features/feedback/hooks/useReview";
import { useAppStore } from "@hooks/useAppStore";
import Button from "@memorang/ui/components/Button";
import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import AppReviewForm from "@memorang/ui/components/Feedback/AppReviewForm";
import { useKeyboard } from "@react-native-community/hooks";
import { useTranslation } from "react-i18next";

export const AppReviewDialog = () => {
	const {
		handleDismiss,
		handleReviewButtonsClick,
		handleMaybeLater,
		showReviewDialog,
	} = useReview();

	const { keyboardHeight } = useKeyboard();
	const { t } = useTranslation();
	const appFont = useAppStore((store) => store.app.font) || "opensans";

	const buttons = [
		{
			icon: "🤔",
			label: t("dashboard.reviewPrompt.buttons.couldBeBetter"),
			type: "negative" as const,
		},
		{
			icon: "🔥",
			label: t("dashboard.reviewPrompt.buttons.itsAwesome"),
			type: "positive" as const,
		},
	];

	return (
		<>
			<DialogWrapper
				visible={Boolean(showReviewDialog)}
				handleClose={handleDismiss}
				bottom={keyboardHeight ? keyboardHeight - 200 : 0}
			>
				<Dialog.Icon icon="message-star-outline" />
				<Dialog.Title
					style={{
						textAlign: "center",
					}}
				>
					{t("dashboard.reviewPrompt.title")}
				</Dialog.Title>
				<Dialog.Content>
					<AppReviewForm
						body={t("dashboard.reviewPrompt.body")}
						buttons={buttons}
						appFont={appFont}
						handleButtonsClick={handleReviewButtonsClick}
					/>
				</Dialog.Content>
				<Dialog.Actions>
					<Button onPress={handleMaybeLater}>
						{t("dashboard.reviewPrompt.cta")}
					</Button>
				</Dialog.Actions>
			</DialogWrapper>
		</>
	);
};
